
document.addEventListener('DOMContentLoaded', function () {

  function initSlick() {
    var widthNow = $(window).width();
    var $slider = $("slider-component ul.collection-list.slick-webtech-enable");

    if (widthNow > 767) {
      // Check if Slick is already initialized before applying it
      if (!$slider.hasClass("slick-initialized")) {
        console.log("Initializing Slick..."); // Debugging log
        $slider.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          infinite: false, // Prevent infinite looping
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              },
            },
          ],
        });
      }
    } else {
      // Destroy Slick if initialized when width < 768px
      if ($slider.hasClass("slick-initialized")) {
        console.log("Destroying Slick..."); // Debugging log
        $slider.slick("unslick");
      }
    }
  }

  // Initialize on page load
  initSlick();

  // Re-initialize on window resize
  $(window).on("resize", function () {
    setTimeout(initSlick, 300); // Delay for better performance
  });

$(".collection-list__item.grid__item").hover(
        function () {
            // Add class on hover
            $(this).addClass("hovered");
        },
        function () {
            // Remove class when hover ends
            $(this).removeClass("hovered");
        }
    );






  
  const stickyButton = document.getElementById('sticky-add-to-cart');
  const stickyButtonAtc = document.getElementById('sticky-add-to-cart-button');
  if (stickyButton !== null ) {
  // Use the 'name' attribute to find the main Add to Cart button
  const addToCartButton = document.querySelector('button[name="add"]');
  const stickyButtonArea = document.querySelector('.product-form__buttons');

  // Listen for scroll events
  const isElementFullyScrolledOut = (element) => {
    const rect = element.getBoundingClientRect();
    return rect.bottom <= 0;  // Checks if the bottom of the element has scrolled out of view
  };

  // Listen for scroll events
  window.addEventListener('scroll', function () {
    if (isElementFullyScrolledOut(addToCartButton)) {
      stickyButton.style.display = 'flex';
    } else {
      stickyButton.style.display = 'none';
    }
  });

  // Handle click on sticky add-to-cart button
  stickyButtonAtc.addEventListener('click', function () {
    addToCartButton.click(); // Trigger the original add-to-cart button click event
  });
  }
});
